/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Typography, TypographyProps } from "@mui/material";

type SchrittTitelProps = Pick<TypographyProps, "children">

export default function SchrittTitel(props: SchrittTitelProps) {
    return <Typography variant="h5" paragraph align="center">{props.children}</Typography>;
}